export const WATERMARKING = {
    ACTIVATION: "watermarking-activation",
    FOREGROUND_COLOR: "watermarking-foreground-color",
    BACKGROUND_COLOR: "watermarking-background-color",
    FOREGROUND_COLOR_HEX: "watermarking-foreground-color-hex",
    BACKGROUND_COLOR_HEX: "watermarking-background-color-hex",
    FOREGROUND_OPACITY: "watermarking-foreground-opacity",
    BACKGROUND_OPACITY: "watermarking-background-opacity",
    WATERMARK_TEXT: "watermarking-watermark-text",
    PREVIEW_IMAGE: "watermarking-preview-image",
    SUBMIT: "watermarking-submit",
    CANCEL: "watermarking-cancel",
    DATA_ATTRIBUTE: (index: number) => `watermarking-data-attribute-${index}`,
    ATTRIBUTE_OPTION: (index: number) => `watermarking-attribute-option-${index}`,
    CONFIRMATION_MODAL: {
        ROOT: "watermarking-confirmation-modal-root",
        TITLE: "watermarking-confirmation-modal-title",
        MESSAGE: "watermarking-confirmation-modal-message",
    },
};
